import React from "react";
import Banner from "../../Components/userComponents/Common/Banner";
import StrongFoundations from "../../Components/userComponents/AboutComponents/StrongFoundations";
import StatsCounter from "../../Components/userComponents/AboutComponents/StatsCounter";
import OurVision from "../../Components/userComponents/AboutComponents/OurVision";
import BenefitsFomUs from "../../Components/userComponents/AboutComponents/BenefitsFomUs";
import TrustedBy from "../../Components/userComponents/HomeComponents/TrustedBy";
import RecruitersPartners from "../../Components/userComponents/AboutComponents/RecruitersPartners";

const AboutUs = () => {
  return (
    <div>
      <Banner page="About Us" path="about" />
      <StrongFoundations />
      <StatsCounter />
      <OurVision />
      <BenefitsFomUs />
      <TrustedBy />
      <RecruitersPartners />
    </div>
  );
};

export default AboutUs;
